import { TabConfigItem } from 'src/components/layout/LinkTabsRow'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export interface IuseLinkTabsStore {
    selectedElement: string | 'none'
    setSelectedElement: (el: string) => void
    linkTabsConfig: TabConfigItem[]
    setLinkTabsConfig: (linkTabsConfig: TabConfigItem[]) => void
}

const createLinkTabsStore = (name: string) => {
    const stickyNavStore = create<IuseLinkTabsStore>()(
        devtools(
            (set, get) => ({
                selectedElement: 'none',
                setSelectedElement: (selectedElement) => set({ selectedElement }),
                linkTabsConfig: [],
                setLinkTabsConfig: (linkTabsConfig) => set({ linkTabsConfig }),
            }),
            { name }
        )
    )

    return stickyNavStore
}

export default createLinkTabsStore
